import { useRef } from 'react';
import { Trash } from 'iconsax-react';
import {
  DialogBody,
  DialogClose,
  DialogFooter,
} from '@src/design-system/dialog';
import { Button } from '@src/design-system/button';

interface DeleteConfirmDialogProps {
  title: string | React.ReactNode;
  onConfirm: (closeModal: () => void) => void;
  onCancel?: () => void;
  isLoading?: boolean;
  confirmText?: string;
  cancelText?: string;
  icon?: React.ReactNode;
}

export function DeleteConfirmDialog({
  title,
  onConfirm,
  isLoading = false,
  confirmText = 'Yes, remove',
  cancelText = 'No, back',
  onCancel,
  icon = (
    <Trash
      className='text-red-500'
      variant='TwoTone'
    />
  ),
}: DeleteConfirmDialogProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const closeModal = () => {
    closeRef.current?.click();
  };

  return (
    <>
      <DialogBody className='flex justify-center items-center flex-col'>
        {icon ? (
          <span className='size-14 flex justify-center items-center rounded-full text-destructive mb-4'>
            {icon}
          </span>
        ) : (
          <span className='size-10 flex justify-center items-center rounded-xl bg-red-50 text-destructive mb-4'>
            <Trash
              className='text-red-500'
              variant='TwoTone'
            />
          </span>
        )}
        {typeof title === 'string' ? (
          <span className='text-center text-gray-700 whitespace-pre-line'>
            {title}
          </span>
        ) : (
          title
        )}
      </DialogBody>
      <DialogFooter className='sm:justify-center pt-0'>
        <DialogClose ref={closeRef}>
          <Button
            variant='primaryOutline'
            className='text-gray-800 border-pale-border'
            onClick={onCancel}
          >
            {cancelText}
          </Button>
        </DialogClose>
        <Button
          isLoading={isLoading}
          disabled={isLoading}
          variant='danger'
          onClick={() => {
            onConfirm(closeModal);
          }}
        >
          {confirmText}
        </Button>
      </DialogFooter>
    </>
  );
}
